import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProjectContextService } from '../../services/project-context.service';
import { Project } from '../../models/project.model';
import { ProjectNameDialogComponent } from './project-name-dialog.component';
import { AvatarComponent, BadgeComponent } from './ui/ui';

/** Lists all of a tenant's projects with rename + activate/deactivate controls. */
@Component({
  selector: 'app-manage-projects-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    AvatarComponent,
    BadgeComponent
  ],
  templateUrl: './manage-projects-dialog.component.html',
  styleUrl: './manage-projects-dialog.component.scss'
})
export class ManageProjectsDialogComponent {
  readonly projectContext = inject(ProjectContextService);
  private readonly dialog = inject(MatDialog);

  trackById(_index: number, project: Project): string {
    return project.id;
  }

  rename(p: Project): void {
    this.dialog.open(ProjectNameDialogComponent, {
      width: '440px',
      data: {
        title: 'Rename project',
        confirmText: 'Save name',
        name: p.name,
        icon: 'edit',
        subtitle: 'Renaming changes how this agent is listed. Nothing else about it moves.'
      }
    }).afterClosed().subscribe((name: string | undefined) => {
      if (name && name !== p.name) this.projectContext.renameProject(p.id, name).subscribe();
    });
  }

  toggle(p: Project): void {
    this.projectContext.setProjectActive(p.id, !p.isActive).subscribe();
  }
}
